export default __webpack_public_path__ + "static/media/AcceleronsGallery_45.bee1338b.webp";